/* eslint-disable react/sort-comp,react/require-default-props */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';
import nprogress from 'nprogress';
import enhanceWithClickOutside from 'react-click-outside';

import SimpleAvatar from '../common/SimpleAvatar';
import EditBtn from '../Button/EditBtn';
import Icon from '../Icon';
import { COLORS } from '../../constants/styles';
import { PROFILE, COMMON } from '../../constants/strings';
import styles from './index.styl';

class Avatar extends PureComponent {
  state = {
    isOpened: false,
  };

  componentWillMount() {
    this.handleError = this.handleError.bind(this);
    this.handleRemoveAvatar = this.removeAvatar.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const method = nextProps.loading ? nprogress.start : nprogress.done;

    method();
  }

  handleError() {
    this.setState({
      isOpened: false,
    });
  }

  getEditButton() {
    return (
      <div key="edit-btn" styleName={classNames('edit-button')}>
        <EditBtn accent onClick={() => this.setState({ isOpened: true })} />
      </div>
    );
  }

  getActions() {
    const {
      src,
      intl: { formatMessage },
    } = this.props;
    const updateLabel = src
      ? formatMessage(PROFILE.avatar.update)
      : formatMessage(PROFILE.avatar.upload);

    return (
      <div styleName={classNames('actions')} className="bsw2-1" key="actions">
        <label
          styleName={classNames(['avatar-input-label', 'action'])}
          htmlFor="avatar-file"
        >
          <Icon
            name="image"
            size={16}
            style={{
              fill: COLORS.bluePrimary,
              marginRight: 10,
            }}
          />
          {updateLabel}
        </label>
        <input
          id="avatar-file"
          type="file"
          accept="image/jpg, image/jpeg, image/png"
          style={{ display: 'none' }}
          onChange={e => this.onFilesChanged(e)}
        />
        <If condition={src}>
          <div
            styleName={classNames('action')}
            onClick={this.handleRemoveAvatar}
            key="remove-action"
          >
            <Icon
              name="remove"
              size={16}
              style={{
                fill: COLORS.bluePrimary,
                marginRight: 10,
              }}
            />
            <FormattedMessage {...COMMON.remove} />
          </div>
        </If>
      </div>
    );
  }

  handleClickOutside() {
    this.setState({ isOpened: false });
  }

  onFilesChanged(e) {
    e.stopPropagation();
    e.preventDefault();
    this.setState({ isOpened: false });

    const { onChange } = this.props;
    const fileSource = e.target;
    const file = fileSource.files[0];

    if (!file.type.includes('image/') || file.type === 'image/gif') {
      return;
    }

    const formData = new FormData();

    formData.append('avatar', file);

    onChange(formData);
  }

  removeAvatar() {
    const { onRemove } = this.props;
    this.setState({ isOpened: false });

    onRemove();
  }

  render() {
    const {
      bordered,
      size,
      editable,
      sizePercent,
      rootStyle,
      noTransparent,
      src,
      children,
    } = this.props;
    const { isOpened } = this.state;
    const emptyAvatar = children && children[0].toUpperCase();

    return (
      <div key="root" styleName={classNames('root')} style={rootStyle}>
        <If condition={editable}>
          {this.getEditButton()}
          <If condition={isOpened}>{this.getActions()}</If>
        </If>

        <SimpleAvatar
          size={size}
          src={src}
          text={emptyAvatar}
          bordered={bordered}
          opaque={noTransparent}
          usePercent={sizePercent}
          onError={this.handleError}
        />
      </div>
    );
  }
}

Avatar.propTypes = {
  bordered: PropTypes.bool,
  children: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.string,
  size: PropTypes.number,
  src: PropTypes.string,
  editable: PropTypes.bool,
  style: PropTypes.object,
  loading: PropTypes.bool,
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
  position: PropTypes.string,
  sizePercent: PropTypes.bool,
  rootStyle: PropTypes.object,
  noTransparent: PropTypes.bool,
};

Avatar.defaultProps = {
  bordered: false,
  size: 24,
};

export default injectIntl(
  enhanceWithClickOutside(CSSModules(Avatar, styles, { allowMultiple: true })),
);



// WEBPACK FOOTER //
// ./src/components/Avatar/index.jsx